import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ './components/YabbrBrochure.vue'),
  },
  {
    path: '/campaigns',
    name: 'CampaignsPage',
    component: () => import(/* webpackChunkName: "about" */ './components/CampaignsPage.vue'),
  },
  {
    path: '/workflows',
    name: 'WorkflowsPage',
    component: () => import(/* webpackChunkName: "about" */ './components/WorkflowsPage.vue'),
  },
  {
    path: '/chat',
    name: 'ChatPage',
    component: () => import(/* webpackChunkName: "about" */ './components/ChatPage.vue'),
  },
  {
    path: '/collections',
    name: 'CollectionsPage',
    component: () => import(/* webpackChunkName: "about" */ './components/CollectionsPage.vue'),
  },
  {
    path: '/channels',
    name: 'ChannelsPage',
    component: () => import(/* webpackChunkName: "about" */ './components/ChannelsPage.vue'),
  },
  {
    path: '/gov',
    name: 'GovPage',
    component: () => import(/* webpackChunkName: "about" */ './components/GovPage.vue'),
  },
  {
    path: '/memberships',
    name: 'MembershipPage',
    component: () => import(/* webpackChunkName: "about" */ './components/MembershipPage.vue'),
  }

];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

export default router;
